import { render, staticRenderFns } from "./vanFieldCheckbox.vue?vue&type=template&id=c86fbc5a&scoped=true&"
import script from "./vanFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./vanFieldCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./vanFieldCheckbox.vue?vue&type=style&index=0&id=c86fbc5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86fbc5a",
  null
  
)

export default component.exports